module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectdate",
    class: {
      selectdate_card: _vm.flag
    }
  }, [_c('DatePicker', {
    staticClass: "selectdate__item",
    attrs: {
      "label": "Дата проведения",
      "value": _vm.value,
      "disabledDates": _vm.disabledDates,
      "highlighted": _vm.activeDates
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }), _c('HourSelect', {
    staticClass: "selectdate__item",
    attrs: {
      "label": "Время",
      "large": true,
      "wide": true,
      "bold": false,
      "options": _vm.options,
      "placeholder": "Выбрать время"
    },
    model: {
      value: (_vm.timeId),
      callback: function($$v) {
        _vm.timeId = $$v
      },
      expression: "timeId"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a98bb02","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderDatepicker.vue
// module id = 373c9578a3d624fc3bd2
// module chunks = 0